import { inject, Injectable } from '@angular/core';
import { ICustomerRegistration } from './customer-registration.model';
import { ICompany } from '@shared-ikp/model/company.model';
import { Address, createAddress } from '@mwe/models';
import { SessionStorageService } from '@mwe/utils';

@Injectable({
  providedIn: 'root',
})
export class CustomerRegistrationSessionstorageService {
  private readonly REGISTRATION_MODEL_KEY = 'GKU_registrationModelState';

  sessionStorageService = inject(SessionStorageService);

  storeRegistrationState(model: ICustomerRegistration): void {
    if (model.companies.length === 0 && model.berater === null && model.email === '') {
      this.sessionStorageService.clear(this.REGISTRATION_MODEL_KEY);
      return;
    }

    this.sessionStorageService.store(this.REGISTRATION_MODEL_KEY, JSON.stringify(model));
  }

  retrieveRegistrationState(): ICustomerRegistration | null {
    const state = this.sessionStorageService.retrieve(this.REGISTRATION_MODEL_KEY);
    return state ? this.fromJsonState(state) : null;
  }

  private fromJsonState(json: string): ICustomerRegistration {
    const state = JSON.parse(json);
    return {
      companies: state.companies.map(company => {
        return {
          ...(company as ICompany),
          address: this.addressStateToAddress(company.address),
        };
      }),
      berater: state.berater,
      email: state.email,
    } as ICustomerRegistration;
  }

  private addressStateToAddress(address: Address): Address {
    return createAddress({
      id: address.id,
      street: address.street,
      streetNumber: address.streetNumber,
      block: address.block,
      doorNumber: address.doorNumber,
      hint: address.hint,
      postcode: address.postcode,
      city: address.city,
      country: address.country,
    });
  }
}
